var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgVolume = function SvgVolume(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_752_351)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.99745 1.27612L8.88341 4.3634C9.45415 4.97355 9.84292 5.75107 10.0005 6.59761C10.1581 7.44415 10.0775 8.32168 9.76885 9.11919C9.46019 9.91671 8.93737 10.5984 8.2665 11.078C7.59564 11.5576 6.80688 11.8136 6 11.8136C5.19312 11.8136 4.40436 11.5576 3.7335 11.078C3.06263 10.5984 2.53981 9.91671 2.23115 9.11919C1.92249 8.32168 1.84187 7.44415 1.99947 6.59761C2.15708 5.75107 2.54585 4.97355 3.11659 4.3634L5.99745 1.27612Z",
    fill: "#2E3744",
    stroke: "#2E3744",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_752_351"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgVolume);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "volume.9928fe89fcd7228183b952acb9681366.svg";